import { useContext } from 'react';

import ModalContext from './modal.context';

function useModal() {
  const context = useContext(ModalContext);

  if (!context) {
    throw new Error('useModal must be used within ModalContext');
  }

  return context;
}

export default useModal;